import { Form } from "formik";
import { isObject } from "lodash";
import React from "react";

import Button from "../../UI/Button";
import { CustomForm } from "../../../component-library/CustomForm";
import FormikInput from "../../UI/FormikInput";

const AdmitPatientPopup = (props) => {
  const { hidePopup, admitPatient, fullName } = props;

  let displayName = fullName;

  if (isObject(fullName)) {
    displayName = `${fullName.f_name} ${fullName.l_name}`;
  }

  let renderForm = (formikProps) => {
    return (
      <Form>
        <div className="PatientStatusPopUp__btn-wpr d-flex pt-3 my-4 tw:justify-center">
          <Button type="button" className="Btn Btn--otl-pri Btn-sm mx-2" onClick={hidePopup}>
            Cancel
          </Button>
          <Button type="submit" className="Btn Btn--pri Btn-sm mx-2">
            Yes Admit
          </Button>
        </div>
        <FormikInput
          formEl={{
            name: "note",
            elementType: "textarea",
            elementConfig: {
              type: "textarea",
              label: "Note",
              placeholder: "Note",
            },
          }}
          errors={formikProps.errors}
          touched={formikProps.touched}
        />
      </Form>
    );
  };

  return (
    <div className="admitPatientPopUp position-fixed d-flex align-items-center tw:justify-center">
      <div className="PatientStatusPopUp__inner d-flex flex-column text-center position-absolute px-4">
        <h2 className="fs-17 mt-4 tw:font-bold">Admit to 90 Day Care</h2>
        <span className="fs-15 mt-2">
          Are you sure you want to admit{" "}
          <span className="mt-1 pt-1 tw:font-bold">{displayName}</span> in 90 day care program?{" "}
        </span>
        <CustomForm onSubmit={admitPatient} render={renderForm} initialValues={{}} />
      </div>
    </div>
  );
};

export default AdmitPatientPopup;
